export default __webpack_public_path__ + "img/8537919b.svg";